import { HOME_THEME } from "../homeTheme";

/** Tokens visuales del Camino principiante (Serenity + mint/lavender). */
export const BEGINNER_PATH_THEME = {
  ...HOME_THEME,
  eyebrowMint: "rgba(153, 246, 228, 0.55)",
  eyebrowLavender: "rgba(196, 181, 253, 0.55)",
  cardBg: "rgba(255,255,255,0.02)",
  cardBgDone: "rgba(153, 246, 228, 0.12)",
  cardBorder: "rgba(255,255,255,0.08)",
  cardBorderMint: "rgba(153, 246, 228, 0.35)",
  cardBorderLavender: "rgba(196, 181, 253, 0.35)",
  btnMint: "linear-gradient(135deg, #99f6e4, #7ecfc0)",
  btnLavender: "linear-gradient(135deg, #c4b5fd, #a89eb8)",
  textSoft: "rgba(255,255,255,0.6)",
  textMuted: "rgba(255,255,255,0.5)",
  textDim: "rgba(255,255,255,0.4)",
  progressTrack: "rgba(255,255,255,0.1)",
  progressFill: "linear-gradient(90deg, #99f6e4, #c4b5fd)",
} as const;

export type BeginnerPathAccent = "mint" | "lavender";

export function pathAccentBorder(accent: BeginnerPathAccent): string {
  return accent === "mint"
    ? BEGINNER_PATH_THEME.cardBorderMint
    : BEGINNER_PATH_THEME.cardBorderLavender;
}

export function pathAccentEyebrow(accent: BeginnerPathAccent): string {
  return accent === "mint"
    ? BEGINNER_PATH_THEME.eyebrowMint
    : BEGINNER_PATH_THEME.eyebrowLavender;
}

export function pathAccentButton(accent: BeginnerPathAccent): string {
  return accent === "mint"
    ? BEGINNER_PATH_THEME.btnMint
    : BEGINNER_PATH_THEME.btnLavender;
}
